import { render, staticRenderFns } from "./SortMobile.vue?vue&type=template&id=1d615c4c&scoped=true&"
import script from "./SortMobile.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./SortMobile.vue?vue&type=script&lang=ts&scoped=true&"
import style0 from "./SortMobile.vue?vue&type=style&index=0&id=1d615c4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d615c4c",
  null
  
)

export default component.exports